import { readSessionClock } from './session-clock-headers';
import type { SessionClockUpdate } from './session-clock-headers';

type SessionActivityListener = (activity: SessionClockUpdate) => void;

const listeners = new Set<SessionActivityListener>();

export function notifySessionActivity(activity: SessionClockUpdate): void {
  for (const listener of listeners) {
    listener(activity);
  }
}

export function subscribeToSessionActivity(listener: SessionActivityListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function readSessionHeaders(headers: Headers): void {
  notifySessionActivity(readSessionClock(headers));
}
